import React, { useState, useEffect } from 'react';
import {
  updateLeadPropertyIdentified,
  leadPropertyIdentified
} from '../../constants/api';
import PopUp from '../PopUp/PopUp';
import { getApplicantionInfo } from '../../utils/applicantionInfo';
import PropertySelectionBox from './PropertySelectionBox';
import { navigate } from 'gatsby';
import SuccessPopUP from '../PropertyThankYouPage/PropertyThankYouPage';
import withErrorHandler from '../../../hoc/withErrorHandler/withErrorHandler';

const PropertyStarter = () => {
  const [loading, setLoading] = useState();
  const [propertyStatus, setPropertyStatus] = useState();
  const [showThankyouPage, setShowTahnkYouPage] = useState();
  const [loadingDetails, setLoadingDetails] = useState({
    type: 'loading',
    text: 'Getting  the property state. Please wait...',
    dontClose: true
  });

  const getLeadPropertyStatus = () => {
    setLoading(true);
    setLoadingDetails({
      type: 'loading',
      text: 'Getting  the property state. Please wait...',
      dontClose: true
    });

    leadPropertyIdentified(getApplicantionInfo().leadId)
      .then(res => {
        setLoading(false);
        setPropertyStatus(res);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const updateLeadPropertyStatus = propertyIdentified => {
    setLoading(true);
    setLoadingDetails({
      type: 'loading',
      text: 'Updating the property state. Please wait...',
      dontClose: true
    });
    updateLeadPropertyIdentified(
      getApplicantionInfo().leadId,
      propertyIdentified
    )
      .then(res => {
        setLoading(false);
        if (propertyIdentified) navigate('/app/propertyDetails');
        else setShowTahnkYouPage(true);
      })
      .catch(error => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getLeadPropertyStatus();
  }, []);

  return (
    <div className="w-full ">
      <div className="xsm:table  mx-auto">
        <div className="block xsm:flex flex-wrap gap-2">
          <PropertySelectionBox
            propertyStatus={propertyStatus}
            src="/sharedImg/property_search.png"
            hanldeClick={() => {
              updateLeadPropertyStatus(true);
              setPropertyStatus(true);
            }}
            text="Property identified"
          />
          <PropertySelectionBox
            propertyStatus={!propertyStatus}
            src="/sharedImg/property_not_searched.png"
            hanldeClick={() => {
              updateLeadPropertyStatus(false);
              setPropertyStatus(false);
            }}
            text="Property not identified"
          />
        </div>
      </div>
      <PopUp
        type={loadingDetails.type}
        text={loadingDetails.text}
        show={loading}
        setShow={setLoading}
        dontClose={loadingDetails.dontClose}
      />
      <SuccessPopUP show={showThankyouPage} setShow={setShowTahnkYouPage} />
    </div>
  );
};

export default withErrorHandler(PropertyStarter);
